import { createReducer, on } from '@ngrx/store';
import { addPublicUserAccounts, loadPublicUserAccounts } from '../actions/public-user-account.actions';


export const publicUserAccountFeatureKey = 'publicUserAccount';

export interface State {

}

export const initialState: State = {

};


export const publicUserReducer = createReducer(
  initialState,
  on(loadPublicUserAccounts, (state, { PublicUserAccount }) => ({
     PublicUserAccount: PublicUserAccount})
  ),
  on(addPublicUserAccounts, (state, {PublicUserAccount}) => {
     return {
     ...state,
     PublicUserAccount: PublicUserAccount
     };
   })
 );


